import { useState } from 'react';
import Sidemenu from '../components/base/sidemenu';
import Log from '../components/log/log';
import LogAlim from '../components/log/log_alim';
import { decodeToken } from '../utils/jwtUtils';
import './LogPage.css';

export default function LogPage() {
  const token = localStorage.getItem('token');
  const user = token ? decodeToken(token) : null;

  const auth = Number(user?.auth);
  const isSuperAdmin = auth === 1;
  const canViewAlerts = auth === 1 || auth === 2;

  const [tab, setTab] = useState(
    isSuperAdmin ? 'logpage' : 'log_alim'
  );
  const [logTotal, setLogTotal] = useState(null);

  return (
    <div className="flex log-management-layout">
      <Sidemenu />

      <main className="log-management-content">
        <div className="log-management-page">
          {!canViewAlerts ? (
            <div className="log-management-panel">
              접근 권한이 없습니다.
            </div>
          ) : (
            <>
              <div className="log-management-header">
                <div>
                  <h2>
                    {isSuperAdmin
                      ? '로그 및 알림 관리'
                      : '알림 관리'}
                  </h2>
                  <p>
                    {isSuperAdmin
                      ? '시스템 작업 이력 및 이상 알림 발생 내역'
                      : '응급 알림 발생 및 처리 이력'}
                  </p>
                </div>

                {isSuperAdmin &&
                  tab === 'logpage' &&
                  logTotal !== null && (
                    <span className="log-management-total">
                      전체 {logTotal.toLocaleString()}건
                    </span>
                  )}
              </div>

              <div className="log-management-tabs">
                {isSuperAdmin && (
                  <button
                    type="button"
                    className={tab === 'logpage' ? 'active' : ''}
                    onClick={() => setTab('logpage')}
                  >
                    로그 관리
                  </button>
                )}

                <button
                  type="button"
                  className={tab === 'log_alim' ? 'active' : ''}
                  onClick={() => setTab('log_alim')}
                >
                  알림 관리
                </button>
              </div>

              <div className="log-management-panel">
                {isSuperAdmin && tab === 'logpage' && (
                  <Log onTotalChange={setLogTotal} />
                )}

                {tab === 'log_alim' && <LogAlim />}
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
